import PageHeader from "../../components/PageHeader";
import { RiepilogoSegnalatoriPanel } from "../../components/RiepilogoSegnalatoriPanel";
import { Users } from "lucide-react";

export default function RiepilogoSegnalatori() {
  return (
    <div data-testid="riepilogo-segnalatori-page">
      <PageHeader
        title="Riepilogo Segnalatori"
        subtitle="Provvigioni maturate da ogni segnalatore sulle pratiche, calcolate dalle quietanze."
        icon={Users}
      />
      <RiepilogoSegnalatoriPanel />
    </div>
  );
}
